'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _momentRange = require('moment-range');

var _util = require('./util');

var _dayGridLocal = require('./day-grid.local.css');

var _dayGridLocal2 = _interopRequireDefault(_dayGridLocal);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

var _chevron = require('./chevron');

var _chevron2 = _interopRequireDefault(_chevron);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var moment = (0, _momentRange.extendMoment)(_momentTimezone2.default);
var TIME_ZONE = 'America/Los_Angeles';

var DayGrid = function (_Component) {
  _inherits(DayGrid, _Component);

  function DayGrid(props) {
    _classCallCheck(this, DayGrid);

    var _this = _possibleConstructorReturn(this, (DayGrid.__proto__ || Object.getPrototypeOf(DayGrid)).call(this, props));

    _this.getWeeklyAggregateRange = function () {
      var aggregatesLastUpdated = _this.props.aggregatesLastUpdated;

      var endDate = _this.moment(aggregatesLastUpdated).startOf('day').subtract(1, 'day');

      var startDate = endDate.clone().subtract(12, 'weeks').startOf('isoWeek');
      return moment.range(startDate, endDate);
    };

    _this.getDailyAggregateRange = function () {
      var aggregatesLastUpdated = _this.props.aggregatesLastUpdated;

      var ninetyOneDaysAgo = _this.moment(aggregatesLastUpdated).startOf('day').subtract(91, 'days');

      var startDate = ninetyOneDaysAgo.isBefore(_this.moment('2018-01-01')) ? _this.moment('2018-01-01') : ninetyOneDaysAgo;
      return moment.range(startDate, _this.moment(aggregatesLastUpdated).endOf('day').subtract(1, 'day'));
    };

    _this.computeSelectedMonth = function () {
      var _this$props = _this.props,
          selectedMonth = _this$props.selectedMonth,
          hasPermissionForMonth = _this$props.hasPermissionForMonth,
          endDate = _this$props.endDate,
          aggregatesLastUpdated = _this$props.aggregatesLastUpdated;

      if (selectedMonth === null || selectedMonth === undefined) {
        var latestAvailableAggDate = _this.moment(aggregatesLastUpdated).subtract(1, 'day');

        if (hasPermissionForMonth(latestAvailableAggDate.month(), latestAvailableAggDate.year())) {
          return latestAvailableAggDate.month();
        } // default to last month that user has permissions for


        return _this.moment(endDate).month();
      }

      return _this.props.selectedMonth;
    };

    _this.moment = function (date) {
      return moment.tz(date || undefined, TIME_ZONE);
    };

    _this.isPrevMonthAvailable = function () {
      var _this$props2 = _this.props,
          aggregatesLastUpdated = _this$props2.aggregatesLastUpdated,
          hasPermissionForMonth = _this$props2.hasPermissionForMonth;

      var selectedMonth = _this.computeSelectedMonth();

      var prevMonth = _this.moment(aggregatesLastUpdated).month(selectedMonth - 1);

      if (!hasPermissionForMonth(prevMonth.month(), prevMonth.year())) {
        return false;
      }

      return _this.dailyAggregateRange.contains(prevMonth.endOf('month')) && prevMonth.isAfter(_this.moment('2018-01-01'));
    };

    _this.isNextMonthAvailable = function () {
      var _this$props3 = _this.props,
          hasPermissionForMonth = _this$props3.hasPermissionForMonth,
          aggregatesLastUpdated = _this$props3.aggregatesLastUpdated;

      var selectedMonth = _this.computeSelectedMonth();

      var nextMonth = _this.moment(aggregatesLastUpdated).month(selectedMonth + 1);

      if (!hasPermissionForMonth(nextMonth.month(), nextMonth.year())) {
        return false;
      }

      return nextMonth.startOf('month').isSameOrBefore(_this.dailyAggregateRange.end);
    };

    _this.isChevronHighlighted = function (direction) {
      var selectedMonth = _this.computeSelectedMonth();

      var hoveringPeriod = _this.props.hoveringPeriod;

      if (hoveringPeriod.type !== 'week' || (0, _isString2.default)(hoveringPeriod.date)) {
        return false;
      }

      var hoveringPeriodStartDate = hoveringPeriod.date.start;
      var hoveringPeriodEndDate = hoveringPeriod.date.end;

      if (direction === 'down') {
        return _this.moment(hoveringPeriodEndDate).isAfter(_this.moment().month(selectedMonth).endOf('month')) && _this.isNextMonthAvailable();
      } // direction 'up'


      return _this.moment(hoveringPeriodStartDate).isBefore(_this.moment().month(selectedMonth).startOf('month')) && _this.isPrevMonthAvailable();
    };

    _this.renderWeekSelector = function (week) {
      var _this$props4 = _this.props,
          hasPermissionForWeek = _this$props4.hasPermissionForWeek,
          setHoveringPeriod = _this$props4.setHoveringPeriod,
          id = _this$props4.id,
          setPeriod = _this$props4.setPeriod; // Compute iso start and end of week, since `week` isn't guaranteed to be an iso week,
      // but rather an array of days rendered in a calendar row.

      var isoStartOfWeek = _this.moment(week[0]).startOf('isoWeek');

      var isoEndOfWeek = _this.moment(week[0]).endOf('isoWeek');

      if (!_this.weeklyAggregateRange.contains(isoStartOfWeek) && hasPermissionForWeek(isoStartOfWeek)) {
        return null;
      }

      return _react2.default.createElement('span', {
        tabIndex: 0,
        role: 'button',
        'data-auto': 'week-selector-' + isoStartOfWeek.format('YYYY-MM-DD'),
        onClick: function onClick() {
          setPeriod('selected', 'week', {
            week: isoStartOfWeek.isoWeek(),
            year: isoStartOfWeek.year()
          });
        },
        onMouseEnter: function onMouseEnter() {
          setHoveringPeriod({
            type: 'week',
            date: {
              start: isoStartOfWeek.format('YYYY-MM-DD'),
              end: isoEndOfWeek.format('YYYY-MM-DD')
            }
          }, id);
        },
        onMouseLeave: function onMouseLeave() {
          setHoveringPeriod({
            type: '',
            name: ''
          }, id);
        },
        className: _dayGridLocal2.default.weekSelector
      });
    };

    _this.groupDaysIntoWeeks = function () {
      var selectedMonth = _this.computeSelectedMonth();

      var currentDate = _this.moment();

      var calendarDays = (0, _util.getDaysForCalendar)(selectedMonth, currentDate.year());
      return calendarDays.reduce(function (accWeeks, day, idx) {
        var isDifferentWeek = idx !== 0 && day.isoWeek() !== calendarDays[idx - 1].isoWeek();
        var updatedWeeks = accWeeks;

        if (idx === 0 || isDifferentWeek) {
          updatedWeeks = [].concat(_toConsumableArray(accWeeks), [[day.format('YYYY-MM-DD')]]);
        } else {
          updatedWeeks = [].concat(_toConsumableArray(accWeeks.slice(0, accWeeks.length - 1)), [[].concat(_toConsumableArray(accWeeks[accWeeks.length - 1]), [day.format('YYYY-MM-DD')])]);
        }

        return updatedWeeks;
      }, []);
    };

    _this.isWeekHovered = function (week) {
      var hoveringPeriod = _this.props.hoveringPeriod;

      if (hoveringPeriod.type !== 'week' || (0, _isString2.default)(hoveringPeriod.date)) {
        return false;
      }

      return hoveringPeriod.date.start === _this.moment(week[0]).startOf('isoWeek').format('YYYY-MM-DD') && hoveringPeriod.date.end === _this.moment(week[0]).endOf('isoWeek').format('YYYY-MM-DD');
    };

    _this.isWeekSelected = function (week) {
      var selectedPeriod = _this.props.selectedPeriod;

      if (selectedPeriod.type !== 'week') {
        return false;
      }

      return _this.moment(week[0]).startOf('isoWeek').format('YYYY-MM-DD') === selectedPeriod.date;
    };

    _this.renderWeek = function (week) {
      var _this$props5 = _this.props,
          selectedPeriod = _this$props5.selectedPeriod,
          setPeriod = _this$props5.setPeriod,
          hasPermissionForDay = _this$props5.hasPermissionForDay;
      return week.map(function (date) {
        var day = _this.moment(date).startOf('day');

        var isInDailyAggregateRange = day.isBetween(_this.dailyAggregateRange.start, _this.dailyAggregateRange.end, null, '[]');
        var isDayAvailable = isInDailyAggregateRange && hasPermissionForDay(day.month(), day.year());
        var isDaySelected = selectedPeriod.date === date && selectedPeriod.type === 'day';
        var classes = (0, _classnames5.default)(_dayGridLocal2.default.calendarDay, isDayAvailable && _dayGridLocal2.default.calendarDayInRange, isDaySelected && _dayGridLocal2.default.calendarDaySelected);
        return _react2.default.createElement('button', {
          key: day.format('D-MM'),
          id: 'day-' + day.format('DD-MM-YY'),
          className: classes,
          'data-auto': 'dayButton',
          'data-disabled': !isDayAvailable,
          onClick: function onClick() {
            return isDayAvailable && setPeriod('selected', 'day', {
              day: day.date(),
              month: day.month(),
              year: day.year()
            });
          }
        }, day.format('D'));
      });
    };

    _this.renderDaysOfWeek = function () {
      var days = ['M', 'T', 'W', 'Th', 'F', 'S', 'S'].map(function (day, i) {
        return (// eslint-disable-next-line react/no-array-index-key
          _react2.default.createElement('span', {
            key: day + '-' + i,
            className: _dayGridLocal2.default.calendarDay
          }, day)
        );
      });
      return _react2.default.createElement('div', {
        className: _dayGridLocal2.default.calendarWeek
      }, days);
    };

    _this.dailyAggregateRange = _this.getDailyAggregateRange();
    _this.weeklyAggregateRange = _this.getWeeklyAggregateRange();
    return _this;
  } // compute the selected month. if one is provided in props it will be returned,
  // otherwise it will be computed based on aggregatesLastUpdated and other restrictions.
  // when a day from an incomplete week is hovered and its first or last day is
  // in the previous or next month we should highlight the corresponding chevron
  // to let the user know that certain day(s) will be selected from a different month

  /**
   * @param  {Array} week
   * Array of strings in a YYYY-MM-DD format representing days rendered in a calendar row.
   * It doesn't always have 7 elements especially the first and last day of the month because
   * of the calendar layout.
   */
  // create a matrix of days ('YYYY-MM-DD') strings to be rendered in the calendar

  /**
   * @param  {Array} week An array of strings ('YYYY-MM-DD')
   * @return {Array}      Array of React nodes
   */


  _createClass(DayGrid, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedMonth = this.computeSelectedMonth();
      var _props = this.props,
          setSelectedMonth = _props.setSelectedMonth,
          id = _props.id;
      var weeks = this.groupDaysIntoWeeks();
      return _react2.default.createElement('div', {
        className: _dayGridLocal2.default.calendar
      }, _react2.default.createElement(_chevron2.default, {
        direction: 'up',
        'data-auto': 'prevMonth',
        className: (0, _classnames5.default)(_datepickerLocal2.default.month, _defineProperty({}, _datepickerLocal2.default.highlighted, this.isChevronHighlighted('up'))),
        handleClick: function handleClick() {
          return setSelectedMonth(selectedMonth - 1, id);
        },
        disabled: !this.isPrevMonthAvailable()
      }), _react2.default.createElement('h4', {
        'data-auto': 'currMonth',
        className: _dayGridLocal2.default.header
      }, this.moment().month(selectedMonth).format('MMMM')), _react2.default.createElement('div', {
        className: _dayGridLocal2.default.calendarContainer
      }, this.renderDaysOfWeek(), _react2.default.createElement('div', {
        'data-auto': 'calendarMonth',
        className: (0, _classnames5.default)(_dayGridLocal2.default.calendarMonth, _dayGridLocal2.default.calendarMonthCurrent)
      }, weeks.map(function (week) {
        var _classnames2;

        return _react2.default.createElement('div', {
          className: _dayGridLocal2.default.calendarWeekRow,
          key: week[0]
        }, _this2.renderWeekSelector(week), _react2.default.createElement('div', {
          className: (0, _classnames5.default)(_dayGridLocal2.default.calendarWeek, (_classnames2 = {}, _defineProperty(_classnames2, _dayGridLocal2.default.hovered, _this2.isWeekHovered(week)), _defineProperty(_classnames2, _dayGridLocal2.default.selected, _this2.isWeekSelected(week)), _classnames2))
        }, _this2.renderWeek(week)));
      }))), _react2.default.createElement(_chevron2.default, {
        'data-auto': 'nextMonth',
        direction: 'down',
        className: (0, _classnames5.default)(_datepickerLocal2.default.month, _defineProperty({}, _datepickerLocal2.default.highlighted, this.isChevronHighlighted('down'))),
        handleClick: function handleClick() {
          return setSelectedMonth(selectedMonth + 1, id);
        },
        disabled: !this.isNextMonthAvailable()
      }));
    }
  }]);

  return DayGrid;
}(_react.Component);

DayGrid.propTypes = {
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  setPeriod: _propTypes2.default.func.isRequired,
  hasPermissionForDay: _propTypes2.default.func.isRequired,
  hasPermissionForMonth: _propTypes2.default.func.isRequired,
  hasPermissionForWeek: _propTypes2.default.func.isRequired,
  setSelectedMonth: _propTypes2.default.func.isRequired,
  setHoveringPeriod: _propTypes2.default.func.isRequired,
  // YYYY-MM-DD date until aggregates are available in db
  aggregatesLastUpdated: _propTypes2.default.string.isRequired,
  // YYYY-MM-DD user permission endDate
  endDate: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired,
  hoveringPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(_constants2.default.datePickerPeriods),
    date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
  }),
  // a zero-based numeric month of aggregatesLastUpdated's year that is currently active (visible under Days tab).
  // if none is provided it means that user didn't explicitly select one, so this component
  // will default to a month based on aggregatesLastUpdated and other restrictions.
  // it can also be negative, which means that the month is in the previous year.
  // Example: aggregatesLastUpdated=2018-04-01. selectedMonth=-1 means the current selected month is December 2017.
  selectedMonth: _propTypes2.default.number
};
exports.default = DayGrid;